import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button'
import { getPreferencesByEmail, updatePreferences } from '../Functions';
import Error from '../pages/Error';

export default class Preferences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email : this.props.email,
      channel : this.props.channel, // source of change, olb, mob, staff, unsub link
      categories : this.props.categories[0].sort((a,b) => (a.CategoryDisplaySeq > b.CategoryDisplaySeq) ? 1 : -1), // all of the categories, 0 index is to unpack the array
      category : this.props.category,
      preferences : [],
      initialPrefs : {},
      prefUnion : {},
      updatedPrefs : {},
      loading : true,
      submitLoad : false,
      allSelected : false,
      noneSelected: false,
      error : false,
      submitted : false,
      successMessage : false,
      noResults: false,
    }
	}

  async componentDidMount() {
    this.populatePreferences();
  }

  async populatePreferences() {
    const preferences = await this.fetchPreferences();
    const categories = this.state.categories;

    let prefUnion = {};
    let initialPrefs = {};
    
    if (preferences === null) {
      this.setState({error:true});
      this.props.parentError(true);
      return;
    }

    if (preferences === undefined || !preferences.length) {
      this.setState({noResults: true, loading: false});
      return;
    }

    preferences.forEach( i => {
      prefUnion[i.CategoryCode] = i.OptInOut;
      initialPrefs[i.CategoryCode] = i.OptInOut;
    });

    categories.forEach ( i => {
      if (!(i.CategoryCode in prefUnion)) {
        prefUnion[i.CategoryCode] = i.DefaultOptInOut;
        initialPrefs[i.CategoryCode] = i.DefaultOptInOut;
      }
    })

    initialPrefs = {...prefUnion};

    const cats = categories.map((x) => {
      return x.CategoryGroupDescription
    });

    const categoryGroups = [...new Set(cats)];

    this.setState({
      preferences : preferences,
      prefUnion : prefUnion,
      initialPrefs : initialPrefs,
      categoryGroups : categoryGroups,
      loading : false
    });
    this.props.loadFunc(false);
    this.checkChecks();
  }

  async fetchPreferences() {
    let prefs = await getPreferencesByEmail(this.state.email).then(resp => {
      return resp;
    });

    if (prefs.data.err) {
			return null;
    } else if (prefs.data === null || prefs.data === [undefined] || prefs.data === undefined) {
      return [];
    }

    if (prefs.data.length) {
      return prefs.data;
    }
  }

  toggleCheckBox = (code) => {
    let prefsTemp = this.state.prefUnion;
    let initialPrefs = this.state.initialPrefs;
    let updatedPrefsTemp = this.state.updatedPrefs;
    let reset = false;
    const cur = this.state.prefUnion[code];

    if (initialPrefs[code] !== prefsTemp[code]) {
      delete updatedPrefsTemp[code]
      reset = true;
    }

    prefsTemp[code] = !cur;

    if (!reset)
      updatedPrefsTemp[code] = prefsTemp[code];

    this.setState({ prefUnion : prefsTemp, updatedPrefs : updatedPrefsTemp });

    this.checkChecks();
  }

  checkChecks = async() => {
    if (Object.keys(this.state.prefUnion).filter(x => this.state.prefUnion[x] === true).length === Object.keys(this.state.prefUnion).length) {
      //all boxes checked
      this.setState({ allSelected: true });
    } else {
      this.setState({ allSelected: false });
    }

    if (Object.keys(this.state.prefUnion).filter(x => this.state.prefUnion[x] === false).length === Object.keys(this.state.prefUnion).length) {
      //all boxes unchecked
      this.setState({ noneSelected: true });
    } else {
      this.setState({ noneSelected: false });
    }
  }

  closeSuccessMessage = () => {
    this.setState( {successMessage: false } )
  }
  
  selectAll = async() => {
    let allBoxes = this.state.categories;
    let initialPrefs = this.state.initialPrefs;
    let prefsTemp = this.state.prefUnion;
    let updatedPrefsTemp = this.state.updatedPrefs;

    allBoxes.map((cata) => {
      prefsTemp[cata.CategoryCode] = true;
      if (initialPrefs[cata.CategoryCode] !== prefsTemp[cata.CategoryCode]) {
        updatedPrefsTemp[cata.CategoryCode] = prefsTemp[cata.CategoryCode];
      } else {
        delete updatedPrefsTemp[cata.CategoryCode];
      }
    });

    this.setState({ prefUnion : prefsTemp, updatedPrefs : updatedPrefsTemp, allSelected: true, noneSelected: false });

  }

  unselectAll = async () => {
    let allBoxes = this.state.categories;
    let initialPrefs = this.state.initialPrefs;
    let prefsTemp = this.state.prefUnion;
    let updatedPrefsTemp = this.state.updatedPrefs;

    allBoxes.map((cata) => {
      prefsTemp[cata.CategoryCode] = false;
      if (initialPrefs[cata.CategoryCode] !== prefsTemp[cata.CategoryCode]) {
        updatedPrefsTemp[cata.CategoryCode] = prefsTemp[cata.CategoryCode];
      } else {
        delete updatedPrefsTemp[cata.CategoryCode];
      }
    });

    this.setState({ prefUnion : prefsTemp, updatedPrefs : updatedPrefsTemp, allSelected: false, noneSelected: true });

  }

  submitForm = async () => {
    let email = this.state.email;
    let prefs = this.state.updatedPrefs;
    let channel = this.state.channel;

    this.setState({ submitLoad : true });

    await updatePreferences(email, channel, prefs).then(
      () => this.setState({ submitted : true })
    ).catch(
      (error) => this.setState({ error : true })
    ).finally(
      () => {
        this.populatePreferences();
        // sets successMessage used by internal RCU success popup; otherwise innocuous
        this.setState({ successMessage: true, submitLoad : false, updatedPrefs : {} })

      }
    );
  }

  renderCheckboxes = () => this.state.categoryGroups.map((catGrp, index) => {
    return (
      <>
        <h4 className="category-header" key={catGrp+index}>{catGrp}</h4>
        {this.state.categories.map((cata, index) => {
          const shouldCheck = this.state.prefUnion[cata.CategoryCode];
          if (cata.CategoryGroupDescription === catGrp)
            return (
              <>
                <div className="custom-control custom-checkbox">
                    <Form.Check
                      type='checkbox'
                      key={index + this.state.email}
                      id={cata.CategoryCode + this.state.email}
                    >
                      <Form.Check.Input className="custom-control-input" type='checkbox' checked={shouldCheck} onChange={() => this.toggleCheckBox(cata.CategoryCode)} id={cata.CategoryCode + this.state.email} />
                      <Form.Check.Label className='custom-control-label'>{cata.CategoryCode === this.state.category ? <b className='highlight'>{cata.CategoryDescription}</b> : cata.CategoryDescription} - <span className="long-description">{cata.LongDescription}</span></Form.Check.Label>
                      
                    </Form.Check>
                </div>
              </>
            )
          return null;
        })}
      </>
    );
  });

	render() {
    if (this.state.loading) {
      return (
        <Spinner animation="border" role="status" id="spinner" size="sm">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      );
    } 

    if (this.state.noResults) {
      return (
        <div className="no-results-container">
          <h3>No preferences found.</h3>
          <p>We could not find any preferences for the selected email address. Please select another email address or try again later.</p>
        </div>
      );
    }

    else if (this.state.error) {
      return (
        <>
          <Error message="An error occurred loading this page, please try again later." />
        </>
      );
    }

    else {
      return (
        <>
          <h3>Communication Preferences for <span className='email-address-header'>{this.state.email}</span></h3>

          <hr />
          
          <p>
            To help you reach your financial goals, we regularly share useful tips and information.
            Your current subscription preferences are represented below by the checked boxes.
          </p>

          {this.state.category &&
            <p>
              The category of the email you selected is outlined below.
              Uncheck this box to unsubscribe from similar emails and press <em>Save Changes</em>.
            </p>
          }

          <p>You can change your preferences any time by logging in to your RCU account.</p>

          <Form>
            { this.renderCheckboxes() }
          </Form>

          <div className="selectUnselect">
            {this.state.allSelected &&
              [<Button disabled variant="link" type="button" >
                Subscribe all
                </Button>, ' ']
            }

            {!this.state.allSelected &&
              [<Button variant="link" type="button" onClick={ () => this.selectAll() }>
                Subscribe all
                </Button>, ' ']
            }
            {this.state.noneSelected &&
              [<Button disabled variant="link" type="button" >
                Unsubscribe all
                </Button>, ' ']
            }
            {!this.state.noneSelected &&
              [<Button variant="link" type="button" onClick={ () => this.unselectAll() }>
                Unsubscribe all
                </Button>, ' ']
            }
          </div>

          <hr />

          {/* Submit button, disables during loading */}
          {!!Object.keys(this.state.updatedPrefs).length &&
            [<Button 
              variant="success" 
              type="submit" 
              disabled={this.state.submitLoad}
              onClick={ () => this.submitForm() } 
              className={this.state.channel === 'MOB' ? 'saveButton mobile' : 'saveButton'}
            >
              {this.state.submitLoad ? 'Loading…' : 'Save Changes'}
            </Button>,' ']
          }

          {!Object.keys(this.state.updatedPrefs).length && 
            [<Button disabled variant="success" type="submit" className={this.state.channel === 'MOB' ? 'saveButton mobile' : 'saveButton'} >
              Save Changes
            </Button>,' ']
          }

          {this.state.submitted && this.state.channel !== "RCU" && 
            <>
              <br /><br />
              <Alert variant='success'>Thank you for providing your communication preferences. It may take up to 10 days for these changes to take effect. We appreciate your patience.</Alert>
            </>
          }

          {this.state.submitted && this.state.channel === "RCU" && this.state.successMessage === true && 
            <>
              <div className='overlayContainer'>
                <div className='overlayBox'>
                  <Button className='close' variant='link' type='button' onClick={() => this.closeSuccessMessage()}>&times;</Button>
                  <div className='successMessage'>
                    <h4>Member's communication preferences updated!</h4>
                    <p>It may take up to 10 days for these changes to take effect. You may close this window.</p>
                  </div>
                </div>
              </div>
            </>
          }
        </>
      );
    }
	}
}